import React from "react";

export interface ChargebackData {
  date: string;
  amount: string;
  reference: string;
  id: number;
  balance: string;
  status: React.ReactNode;
  action: React.ReactNode;
}

export const ColumnChargeback = [
  {
    Header: "Due Date",
    accessor: "date",
  },
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Balance",
    accessor: "balance",
  },
  {
    Header: "Order Reference",
    accessor: "reference",
  },
  {
    Header: "Action",
    accessor: "action",
  },
];
